import React from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import { MobileStickyCTA } from '@/components/brand/MobileStickyCTA';

/**
 * PageShell — wraps a route in the Joy Basket layout.
 * Provides Navbar + Footer + the cream background + spacing
 * to clear the fixed nav. Children render inside <main>.
 *
 * Use `tone="cream"` (default) for content pages, `tone="surface"` for white,
 * or pass any background class via `bgClassName`.
 *
 * stickyMobileCTA: opt-in mobile bottom CTA bar. Default off — pages with
 * their own primary action (dashboard, registry view/edit, onboarding,
 * admin) explicitly omit it. Marketing pages opt in.
 */
export const PageShell = ({
  children,
  tone = 'cream',
  bgClassName,
  hideFooter = false,
  navAuthClick,
  stickyMobileCTA = false,
}) => {
  const bg = bgClassName
    ? bgClassName
    : tone === 'surface'
    ? 'bg-cream-50'
    : 'bg-background';

  return (
    <div className={`min-h-screen ${bg} text-foreground antialiased flex flex-col`}>
      <Navbar onAuthClick={navAuthClick} />
      <main className="flex-1 pt-[68px]">{children}</main>
      {!hideFooter && <Footer />}
      {stickyMobileCTA && <MobileStickyCTA />}
    </div>
  );
};

export default PageShell;
